import { getGlobalArgs } from '@/root/global';

import { always, equals } from './common';

export const isClientSide = always(typeof window !== 'undefined');

export const makeK8sReqHeaders = (headers?: Headers) => {
  if (!headers) return;

  const configsFeatureStandsHeaderName = getGlobalArgs('NEXT_PUBLIC_CONFIGS_FEATURE_STANDS_HEADER_NAME');

  if (!configsFeatureStandsHeaderName) return;

  const fsNameHeader = headers.get(configsFeatureStandsHeaderName);
  if (!fsNameHeader) return;
  return {
    [configsFeatureStandsHeaderName]: fsNameHeader,
  };
};

export const isLocalEnv = equals('local');
